import './HomePageContent.css';

import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useAuth } from '../AuthContext';

// Assets
import bgall from '../assets/darkgreen.avif';
// Hero image
import heroSofaImg from '../assets/homee/section1pic.webp';
// Featured Collections
import modernSofaImg from '../assets/homee/modernsofa.jpg';
import execOfficeImg from '../assets/homee/execofficetable.webp';
import lSofaModernImg from '../assets/homee/lsofamodern.webp';
// Create Your Own steps
import step1Img from '../assets/homee/step1.webp';
import step2Img from '../assets/homee/step2.webp';
import step3Img from '../assets/homee/step1.webp'; // Placeholder for missing step3.png

// Shop by Category images
import livingRoomCatImg from '../assets/shoppage/livingroom.webp';
import diningRoomCatImg from '../assets/shoppage/diningroom.webp';
import bedroomCatImg    from '../assets/shoppage/bedroom.webp';
import officeRoomCatImg from '../assets/shoppage/officeroom.webp';
import outdoorCatImg    from '../assets/shoppage/outdoor.webp';

// Virtual showroom
import showroomImg from '../assets/showroom.webp';

const narraQueenImg = heroSofaImg;




// ─────────────────────────────────────────────────────────────────
//  Hero Carousel — Full-bleed slides
// ─────────────────────────────────────────────────────────────────
const HERO_SLIDES = [
  {
    label: 'Bedroom',
    headlineLead: 'Your Sanctuary,',
    headlineAccent: 'Handcrafted',
    headlineTail: 'in Solid Narra',
    description: 'Wake up to warmth and craftsmanship. Our bedroom collection blends heirloom-quality woodwork with a calm, modern silhouette.',
    cta: 'Shop Now',
    page: 'queensizebed',
    img: bedroomCatImg,
  },
  {
    label: 'Living Room',
    headlineLead: 'Furniture Built',
    headlineAccent: 'to Last',
    headlineTail: 'Generations',
    description: 'From L-shaped sofas to accent pieces, every living room set is designed for real Filipino homes and real family moments.',
    cta: 'Shop Now',
    page: 'sofa',
    img: livingRoomCatImg,
  },
  {
    label: 'Dining Area',
    headlineLead: 'A Table Worth',
    headlineAccent: 'Gathering',
    headlineTail: 'Around',
    description: 'Acacia and narra dining sets, joined and finished by Kapampangan hands, built to hold every family dinner for years to come.',
    cta: 'Shop Now',
    page: 'diningset',
    img: diningRoomCatImg,
  },
  {
    label: 'Office Furniture',
    headlineLead: 'A Workspace',
    headlineAccent: 'That Works',
    headlineTail: 'as Hard as You',
    description: 'Executive desks and ergonomic pieces crafted with the same care as our heirloom furniture, built for focus and built to last.',
    cta: 'Shop Now',
    page: 'officetable',
    img: officeRoomCatImg,
  },
  {
    label: 'Outdoor Furniture',
    headlineLead: 'Bring the Same',
    headlineAccent: 'Craftsmanship',
    headlineTail: 'Outdoors',
    description: 'Weather-ready furniture that keeps its character season after season, built for lanais, gardens, and outdoor entertaining.',
    cta: 'Shop Now',
    page: 'chair',
    img: outdoorCatImg,
  },
];

// ─────────────────────────────────────────────────────────────────
//  Featured Collections — 4 items
// ─────────────────────────────────────────────────────────────────
const FEATURED_ITEMS = [
  { id: '69d25b2066127918e9d708ed', tag:'Living Room', name:'Family Nest L-Sectional', price:'₱28,500', img: lSofaModernImg, page:'sofa', badge:'Best Seller' },
  { id: '69d281b266127918e9d70978', tag:'Office Furniture', name:'Optima Executive Desk', price:'₱18,900', img: execOfficeImg, page:'officetable', badge:'Featured' },
  { id: '6a53c78820c90ca8307038a0', tag:'Bedroom', name:'Six Drawer Oak Dresser', price:'₱22,000', img: narraQueenImg, page:'queensizebed', badge:null },
  { id: '69d2737166127918e9d70934', tag:'Dining Area', name:'Hearth Comfort Dining Set', price:'₱35,000', img: diningRoomCatImg, page:'diningset', badge:'New' },
  { id: '69d2898366127918e9d7099d', tag:'Outdoor Sets', name:'Sunset Haven Lounge Set', price:'₱45,000', img: outdoorCatImg, page:'outdoor', badge:'Popular' },
];

// ─────────────────────────────────────────────────────────────────
//  Shop by Category
// ─────────────────────────────────────────────────────────────────
const CATEGORIES = [
  { name:'Living Area', img: livingRoomCatImg, page:'sofa', big:true },
  { name:'Dining Area', img: diningRoomCatImg, page:'diningset' },
  { name:'Bedroom Area', img: bedroomCatImg, page:'queensizebed' },
  { name:'Office Area', img: officeRoomCatImg, page:'officetable' },
  { name:'Outdoor Area', img: outdoorCatImg, page:'chair' },
];

// ─────────────────────────────────────────────────────────────────
//  Our Work Gallery — live Facebook + Instagram embeds (3 + 3)
// ─────────────────────────────────────────────────────────────────
const GALLERY_EMBEDS = [
  {
    type: 'facebook',
    src: 'https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fukitkapampangan%2Fposts%2Fpfbid02R4m4vunjhdmfiy8dpAPZ4yd58nuNgSAKaV8nGdUGd67HviSJh51M1L1vU984hpS1l&show_text=true&width=500',
    width: 500,
    height: 250,
  },
  {
    type: 'facebook',
    src: 'https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fukitkapampangan%2Fposts%2Fpfbid02ZNNofSXjyEUskSta9t24u3hGtY1KHw89TqmPFzupr5LeKx2Bki8LiF1ri4kvbqgVl&show_text=true&width=500',
    width: 500,
    height: 626,
  },
  {
    type: 'facebook',
    src: 'https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fukitkapampangan%2Fposts%2Fpfbid02JbQSo78F4FJi8LicvTWc74Lo5uezniaAZ7bZeNH4U7zeojPpY6GYztkt8pJGt3GSl&show_text=true&width=500',
    width: 500,
    height: 250,
  },
  { type: 'instagram', permalink: 'https://www.instagram.com/p/DKjmv6WSvaw/' },
  { type: 'instagram', permalink: 'https://www.instagram.com/p/DLBkg16yh66/' },
  { type: 'instagram', permalink: 'https://www.instagram.com/p/DKdZJl9yNzj/' },
];

// Builds the standard Instagram placeholder blockquote markup Instagram's
// embed.js looks for and hydrates into the real post (image, caption, likes).
const buildInstagramEmbedHtml = (permalink) => {
  const href = `${permalink}?utm_source=ig_embed&utm_campaign=loading`;
  return `
    <blockquote class="instagram-media" data-instgrm-captioned data-instgrm-permalink="${href}" data-instgrm-version="14"
      style="background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin:1px; max-width:540px; min-width:326px; padding:0; width:99.375%; width:calc(100% - 2px);">
      <div style="padding:16px;">
        <a href="${href}" style="background:#FFFFFF; line-height:0; padding:0; text-align:center; text-decoration:none; width:100%;" target="_blank" rel="noreferrer">
          <div style="display:flex; flex-direction:row; align-items:center;">
            <div style="background-color:#F4F4F4; border-radius:50%; flex-grow:0; height:40px; margin-right:14px; width:40px;"></div>
            <div style="display:flex; flex-direction:column; flex-grow:1; justify-content:center;">
              <div style="background-color:#F4F4F4; border-radius:4px; flex-grow:0; height:14px; margin-bottom:6px; width:100px;"></div>
              <div style="background-color:#F4F4F4; border-radius:4px; flex-grow:0; height:14px; width:60px;"></div>
            </div>
          </div>
          <div style="padding:19% 0;"></div>
          <div style="display:block; height:50px; margin:0 auto 12px; width:50px;">
            <svg width="50px" height="50px" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g transform="translate(-511.000000, -20.000000)" fill="#000000">
                  <path d="M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631"></path>
                </g>
              </g>
            </svg>
          </div>
          <div style="padding-top:8px;">
            <div style="color:#3897f0; font-family:Arial,sans-serif; font-size:14px; font-weight:550; line-height:18px;">View this post on Instagram</div>
          </div>
        </a>
        <p style="color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin:8px 0 0; padding:8px 0 7px; text-align:center; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
          <a href="${href}" style="color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; font-weight:normal; line-height:17px; text-decoration:none;" target="_blank" rel="noreferrer">A post shared by Woodwork that works for you. (@ukitkapampangan)</a>
        </p>
      </div>
    </blockquote>
  `;
};

// ─────────────────────────────────────────────────────────────────
//  Main HomePage
// ─────────────────────────────────────────────────────────────────

const HomePageContent = ({ paymentStatus }) => {
  const navigate = useNavigate();
  const { showModal } = useOutletContext();
  const { currentUser } = useAuth();
  
  const [heroActive, setHeroActive] = useState(0);
  const [heroPrev, setHeroPrev] = useState(null);
  const heroPrevTimeoutRef = useRef(null);
  
  useEffect(() => {
    const id = setInterval(() => {
      setHeroActive((curr) => {
        setHeroPrev(curr);
        return (curr + 1) % HERO_SLIDES.length;
      });
    }, 5000);
    return () => clearInterval(id);
  }, []);
  
  useEffect(() => {
    if (heroPrev === null) return undefined;
    if (heroPrevTimeoutRef.current) clearTimeout(heroPrevTimeoutRef.current);
    heroPrevTimeoutRef.current = setTimeout(() => setHeroPrev(null), 1150);
    return () => clearTimeout(heroPrevTimeoutRef.current);
  }, [heroPrev]);

  // Fade/slide in sections as they scroll into view
  useEffect(() => {
    const revealEls = document.querySelectorAll('.home-page .reveal, .home-page .reveal-stagger');
    if (!('IntersectionObserver' in window)) {
      revealEls.forEach(el => el.classList.add('is-visible'));
      return undefined;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -60px 0px' });

    revealEls.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  // Instagram embeds
  useEffect(() => {
    const processEmbeds = () => {
      if (window.instgrm && window.instgrm.Embeds) {
        window.instgrm.Embeds.process();
      }
    };

    if (window.instgrm) {
      processEmbeds();
    } else {
      const existing = document.getElementById('ig-embed-script');
      if (existing) {
        existing.addEventListener('load', processEmbeds);
      } else {
        const script = document.createElement('script');
        script.id = 'ig-embed-script';
        script.async = true;
        script.src = 'https://www.instagram.com/embed.js';
        script.onload = processEmbeds;
        document.body.appendChild(script);
      }
    }
    setTimeout(processEmbeds, 500);
  }, []);

  const activeSlide = HERO_SLIDES[heroActive];

  return (
    
      <div className="home-page" style={{ backgroundColor:'#ffffff' }}>
        
        <main>
        {/* ══ HERO — Full-Bleed Animated Carousel ══ */}
        <div className="hero-carousel">
          {/* image stage: previous slide sits beneath the incoming (zoom+fade) image */}
          <div className="hero-image-stage">
            {heroPrev !== null && (
              <div className="hero-slide-image hero-slide-image-prev">
                <img src={HERO_SLIDES[heroPrev].img} alt={HERO_SLIDES[heroPrev].label} width="1920" height="1080" />
              </div>
            )}
            <div className="hero-slide-image hero-slide-image-current" key={`hero-img-${heroActive}`}>
              <img src={activeSlide.img} alt={activeSlide.label} width="1920" height="1080" fetchpriority="high" />
            </div>
          </div>

          {/* text + CTA, left-aligned over the dark scrim */}
          <div className="hero-content" key={`hero-content-${heroActive}`}>
            <div className="hero-eyebrow-carousel">Woodwork that works for you.</div>
            <h1 className="hero-headline">
              {activeSlide.headlineLead}{' '}
              <span className="accent-word">{activeSlide.headlineAccent}</span>{' '}
              {activeSlide.headlineTail}
            </h1>
            <p className="hero-desc">{activeSlide.description}</p>
            <div className="hero-cta-row">
              <button className="hero-pill-btn solid" onClick={() => navigate('/products')} aria-label={`Shop ${activeSlide.label} Collection`}>
                {activeSlide.cta}
              </button>
              <button className="hero-pill-btn outline" onClick={() => navigate('/design-your-own')}>
                Download the App Now <span aria-hidden="true">→</span>
              </button>
            </div>
          </div>
        </div>

        {/* ══ FEATURED COLLECTIONS ══ */}
        <section id="featured-collections" className="fc-section reveal">
          <div className="uk-eyebrow">Popular Picks</div>
          <div className="fc-title">Featured Collections</div>
          <div className="fc-sub">
            Discover our most-loved pieces — handcrafted with pride, designed for lasting elegance in every Filipino home.
          </div>
          <div className="fc-grid reveal-stagger">
            {FEATURED_ITEMS.map((item, i) => (
              <div key={i} className="fc-card" onClick={() => item.id ? navigate(`/product/${item.id}`, { state: { from: 'Home' } }) : navigate(`/products?master=${encodeURIComponent(item.tag)}`, { state: { from: 'Home' } })}>
                <div className="fc-card-img-wrap">
                  <img src={item.img} alt={item.name} className="fc-card-img" width="400" height="300" loading="lazy" />
                  {item.badge && <span className="fc-badge">{item.badge}</span>}
                </div>
                <div className="fc-card-body">
                  <div className="fc-card-tag">{item.tag}</div>
                  <div className="fc-card-name">{item.name}</div>
                  <div className="fc-card-row">
                    <span className="fc-price">{item.price}</span>
                    <button className="fc-view-btn" onClick={e => { e.stopPropagation(); item.id ? navigate(`/product/${item.id}`, { state: { from: 'Home' } }) : navigate(`/products?master=${encodeURIComponent(item.tag)}`, { state: { from: 'Home' } }); }} aria-label={`View details for ${item.name}`}>
                      View
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="fc-showall-wrap">
            <button className="uk-btn uk-btn-outline-forest" onClick={() => navigate('shop')}>View All Products →</button>
          </div>
        </section>

        <div className="home-divider" />

        {/* ══ SHOP BY CATEGORY ══ */}
        <section className="cat-section reveal">
          <div className="cat-top-row">
            <div>
              <div className="uk-eyebrow left">Browse</div>
              <div className="cat-title">Shop by Category</div>
            </div>
            <button className="uk-btn uk-btn-outline-forest" onClick={() => navigate('shop')}>View All Categories →</button>
          </div>
          <div className="cat-grid reveal-stagger">
            <div className="cat-card big" onClick={() => navigate(CATEGORIES[0].page)}>
              <img src={CATEGORIES[0].img} alt={CATEGORIES[0].name} width="600" height="800" loading="lazy" />
              <div className="cat-card-body">
                <span className="cat-card-name">{CATEGORIES[0].name}</span>
                <button className="cat-card-btn" onClick={e => { e.stopPropagation(); navigate(CATEGORIES[0].page); }} aria-label={`Explore ${CATEGORIES[0].name} Category`}>Explore</button>
              </div>
            </div>
            <div className="cat-grid-right">
              {CATEGORIES.slice(1).map((c, i) => (
                <div key={i} className="cat-card" onClick={() => navigate(c.page)}>
                  <img src={c.img} alt={c.name} width="400" height="300" loading="lazy" />
                  <div className="cat-card-body">
                    <span className="cat-card-name">{c.name}</span>
                    <button className="cat-card-btn" onClick={e => { e.stopPropagation(); navigate(c.page); }} aria-label={`Shop ${c.name} Category`}>Shop</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <div className="home-divider" />

        {/* ══ VIRTUAL SHOWROOM ══ */}
        <section id="virtual-showroom" className="vs-section reveal">
          <div className="vs-hero">
            <img src={showroomImg} alt="Virtual showroom" width="1200" height="600" loading="lazy" />
            <div className="vs-hero-body">
              <div className="vs-label">Virtual Walkthrough</div>
              <div className="vs-title">Explore Our <em>Virtual Showroom</em></div>
              <div className="vs-desc">
                Walk through our digital showroom from the comfort of your home. Browse premium furniture setups, explore room designs, and find the perfect piece for your space.
              </div>
              <div className="vs-actions">
                <button className="uk-btn uk-btn-gold">Explore Showroom</button>
                <button className="uk-btn uk-btn-outline-white" onClick={() => navigate('/design-your-own')}>Learn More</button>
              </div>
            </div>
          </div>
        </section>

        <div className="home-divider" />

        {/* ══ CREATE YOUR OWN ══ */}
        <section className="cyo-section reveal">
         <div className="cat-top-row" style={{ marginBottom: 'clamp(22px, 4vw, 34px)' }}>
  <div>
    <div className="uk-eyebrow left">AI Customization</div>
    <div className="cyo-title">Create your own furniture</div>
    <div className="cyo-desc">
      Choose how you want to start: upload your inspiration image or fill up a guided
      form so the system can help choose the right furniture type for your space.
    </div>
  </div>
  <button className="uk-btn uk-btn-outline-forest" onClick={() => navigate('design')}>
    Customize Your Furniture →
  </button>
</div>
          <div className="cyo-steps reveal-stagger">
            {[
              { num:'Step 01', name:'Upload or fill up', text:'Pick an inspiration image or complete the form so we can choose the best furniture type.', img: step1Img },
              { num:'Step 02', name:'Generate 2D to 3D', text:'Turn the concept into a clearer furniture preview with AI-assisted 2D and 3D generation.', img: step2Img },
              { num:'Step 03', name:'Review and submit', text:'Confirm the design details, contact information, and submit your custom request.', img: step3Img },
            ].map((s, i) => (
              <div key={i} className="cyo-step">
                <img src={s.img} alt={s.name} className="cyo-step-img" width="300" height="200" loading="lazy" />
                <div className="cyo-step-body">
                  <div className="cyo-step-num">{s.num}</div>
                  <div className="cyo-step-name">{s.name}</div>
                  <div className="cyo-step-text">{s.text}</div>
                </div>
              </div>
            ))}
          </div>
        </section>

        <div className="home-divider" />

        {/* ══ GALLERY — Our Work ══ */}
        <section id="gallery" className="gal-section reveal">
          <div className="gal-top-row">
            <div>
              <div className="uk-eyebrow left">Portfolio</div>
              <div className="gal-title">Our Work Gallery</div>
            </div>
            <button className="uk-link-teal" onClick={() => navigate('/gallery')}>
              View Full Gallery →
            </button>
          </div>

          <div className="gal-social-label">As Seen on Social Media</div>
          <div className="gal-embed-grid reveal-stagger">
            {GALLERY_EMBEDS.map((embed, i) =>
              embed.type === 'facebook' ? (
                <div key={i} className="gal-embed-card">
                  <iframe
                    src={embed.src}
                    width={embed.width}
                    height={embed.height}
                    style={{ border:'none', overflow:'hidden' }}
                    scrolling="no"
                    frameBorder="0"
                    allowFullScreen
                    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                    title={`Facebook post ${i}`}
                  />
                </div>
              ) : (
                <div
                  key={i}
                  className="gal-embed-card"
                  dangerouslySetInnerHTML={{ __html: buildInstagramEmbedHtml(embed.permalink) }}
                />
              )
            )}
          </div>

          <div className="gal-quote">Crafted with skill, made with heart — the Kapampangan way.</div>
        </section>

        <div className="home-divider" />

        {/* ══ LOCATION & CONTACT ══ */}
        <section id="location" className="reveal">
          <div className="loc-banner">
            <div className="loc-banner-left">
             
              <div className="loc-banner-title">
                Visit Our Office &amp;<br /><span className="accent">Experience the Difference</span>
              </div>
              <p className="loc-banner-desc" style={{ marginTop:'14px', maxWidth:'480px' }}>
                If you would like to know more about Ukit Kapampangan or our Furniture products, drop our team a line and we will be in touch. 
              </p>
            </div>
            <div className="loc-banner-actions">
              <a
                className="loc-banner-btn solid"
                href="https://maps.google.com/?q=XMC2%2B4F4,+Sta.+Ursula+Rd,+Guagua,+Pampanga"
                target="_blank"
                rel="noreferrer"
              >
                Get Directions
              </a>
              <a className="loc-banner-btn outline" href="tel:+639171297167">Call Us Now</a>
            </div>
          </div>

          <div className="loc-section">
            <div className="loc-grid">
              <div className="loc-left">
                <div className="loc-find-us">Find Us</div>
                <div className="loc-heading">Location &amp; <span className="accent">Contact</span></div>

                <div className="loc-info-card">
                  <div className="loc-info-card-label">Address</div>
                  <div className="loc-info-card-value">XMC2+4F4, Sta. Ursula Rd, Guagua, Pampanga</div>
                </div>

                {/* TODO: confirm actual business hours */}
                <div className="loc-hours-row">
                  <div className="loc-info-card">
                    <div className="loc-info-card-label">Mon &ndash; Fri</div>
                    <div className="loc-info-card-value">8:00 AM &ndash; 6:00 PM</div>
                  </div>
                  <div className="loc-info-card">
                    <div className="loc-info-card-label">Sat &ndash; Sun</div>
                    <div className="loc-info-card-value">9:00 AM &ndash; 5:00 PM</div>
                  </div>
                </div>

                <div className="loc-info-card">
                  <div className="loc-info-card-label">Contact</div>
                  <div className="loc-contact-value">+63 917 1297 167</div>
                  <div className="loc-info-card-sub">info@ukitkapampangan.com</div>
                </div>

                <div className="loc-follow-label">Follow Us</div>
                <div className="loc-follow-row">
                  <a className="loc-social-btn" href="https://www.facebook.com/ukitkapampangan" target="_blank" rel="noreferrer">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                    </svg>
                    Facebook
                  </a>
                  <a className="loc-social-btn" href="https://www.instagram.com/ukitkapampangan/" target="_blank" rel="noreferrer">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                    </svg>
                    Instagram
                  </a>
                </div>
              </div>
              <div className="loc-map-wrap">
               
                <iframe
                  className="loc-map-frame"
                  title="Ukit Kapampangan location map"
                  src="https://www.google.com/maps?q=XMC2%2B4F4%2C%20Sta.%20Ursula%20Rd%2C%20Guagua%2C%20Pampanga&t=&z=17&ie=UTF8&iwloc=&output=embed"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
          </div>
        </section>
        </main>
      </div>
    
  );
};

export default HomePageContent;
